import TextWidget from '@/components/widgets/forms/TextWidget'
import HTMLWidget from '@/components/widgets/forms/HTMLWidget'
import LineupWidget from '@/components/widgets/forms/LineupWidget'
import LogotypesWidget from '@/components/widgets/forms/LogotypesWidget'
import SlidesWidget from '@/components/widgets/forms/SlidesWidget'
import NewsletterWidget from '@/components/widgets/forms/NewsletterWidget'
import BoxesWidget from '@/components/widgets/forms/BoxesWidget'
import InformationTilesWidget from '@/components/widgets/forms/InformationTilesWidget'
import FoodVendorsWidget from '@/components/widgets/forms/FoodVendorsWidget/FoodVendorsWidget'
import ArtistsListWidget from '@/components/widgets/forms/ArtistsListWidget/ArtistsListWidget'
import MobileAppWidget from '@/components/widgets/forms/MobileAppWidget'
import EventsListWidget from '@/components/widgets/forms/EventsListWidget'
import InstagramWidget from '@/components/widgets/forms/InstagramWidget'
import TicketsWidget from '@/components/widgets/forms/TicketsWidget'
import ColumnsWidget from '@/components/widgets/forms/ColumnsWidget'
import StandsWidget from '@/components/widgets/forms/StandsWidget'
import GalleriesListWidget from '@/components/widgets/forms/GalleriesListWidget'
import WhatWePlayWidget from '@/components/widgets/forms/WhatWePlayWidget'
import FormWidget from '@/components/widgets/forms/FormWidget'
import PhotoWithTextWidget from '@/components/widgets/forms/PhotoWithTextWidget'
import RepertoireWidget from '@/components/widgets/forms/RepertoireWidget'
import NewsWidget from '@/components/widgets/forms/NewsWidget'
import FAQWidget from '@/components/widgets/forms/FAQWidget'
import BreadcrumbsWidget from '@/components/widgets/forms/BreadcrumbsWidget'

export default {
    PhotoWithTextWidget,
    TextWidget,
    LogotypesWidget,
    LineupWidget,
    SlidesWidget,
    NewsletterWidget,
    HTMLWidget,
    BoxesWidget,
    InformationTilesWidget,
    FoodVendorsWidget,
    ArtistsListWidget,
    MobileAppWidget,
    EventsListWidget,
    InstagramWidget,
    TicketsWidget,
    ColumnsWidget,
    StandsWidget,
    GalleriesListWidget,
    WhatWePlayWidget,
    FormWidget,
    RepertoireWidget,
    NewsWidget,
    FAQWidget,
    BreadcrumbsWidget,
}



// WEBPACK FOOTER //
// ./src/components/widgets/availableWidgetsForms.js